(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brands-info-v2"] && !Shopify.designMode) return;
  try {
    
  const brandsInfoSlider = () => {
    new Swiper('.brands-info__swiper', {
      spaceBetween: 10,
      slidesPerView: 1.1,
      loop: true,
      freeMode: true,
      mousewheel: {
        forceToAxis: true,
      },
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
     },
     breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 2,
        },
        911: {
          slidesPerView: 4,
          spaceBetween: 0,
        }
      },
    })
  }

  document.addEventListener('DOMContentLoaded', () => {
    brandsInfoSlider();
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-complements-home"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    new Swiper('.products-complements-home .swiper-container', {
      breakpoints: {
        320: {
          slidesPerView: 'auto',
        },
      },
      spaceBetween: 0,
      pagination: {
        el: ".products-complements-home .swiper-pagination",
        type: "bullets",
        clickable: true,
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-complements"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    new Swiper('.complement-products .swiper-container', {
      breakpoints: {
        320: {
          slidesPerView: 'auto',
        },
      },
      spaceBetween: 0,
      scrollbar: {
        el: '.complement-products .swiper-scrollbar',
        freeMode: true,
        draggable: true,
        hide: false,
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["why-it-works"] && !Shopify.designMode) return;
  try {
    
  const brandsInfoSlider = () => {
    new Swiper('.why-it-works-content-info-items', {
      spaceBetween: 10,
      slidesPerView: 1,
      loop: true,
      freeMode: false,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
     },
     breakpoints: {
        768: {
          slidesPerView: "auto",
          spaceBetween: 10,
        }
      },
    })
  }

  document.addEventListener('DOMContentLoaded', () => {
    brandsInfoSlider();
  })

  } catch(e) { console.error(e); }
})();
})();
